export default __webpack_public_path__ + "static/media/Dining Area 1.c16ef4f0.jpg";